module.exports = __webpack_public_path__ + "static/media/redButton.973201e2.png";